var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgPromotions = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "#323232",
  strokeLinejoin: "round",
  d: "M8.99 5.365a.5.5 0 0 0 .627-.026l1.307-1.146c.274-.24.624-.372.988-.372h7.648a2.5 2.5 0 0 1 2.499 2.5v11.358c0 1.381-1.118 2.5-2.499 2.5h-7.522a1.5 1.5 0 0 1-1.104-.489l-1.277-1.399a.5.5 0 0 0-.71-.03l-1.64 1.519a1.5 1.5 0 0 1-1.02.399H4.442a2.5 2.5 0 0 1-2.5-2.5V6.32a2.5 2.5 0 0 1 2.5-2.498h1.971c.321 0 .633.103.892.295l.297-.402-.297.402z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  stroke: "#323232",
  strokeLinecap: "round",
  d: "M9.275 8.839v1.598M9.275 13.339v1.598"
})));
export default SvgPromotions;